<template>
    <div>
        <h1 class="fd-news-title">{{ title }}</h1>
        <div class="fd-news-message">
            <p>发布时间：{{ date }}</p>
            <p>发布法院：{{ fy }}</p>
        </div>
        <aty-table class="fd-basic-table fd-mt16 fd-table-01" :pageable-data="data">
            <aty-table-column label="案号" prop="ah"></aty-table-column>
            <aty-table-column label="法院" prop="fy"></aty-table-column>
            <aty-table-column label="承办部门" prop="cbbm"></aty-table-column>
            <aty-table-column label="承办人" prop="cbr"></aty-table-column>
            <aty-table-column label="未上网原因" prop="wswyy"></aty-table-column>
        </aty-table>
    </div>

</template>

<script>
export default {
    name: 'index',
    data() {
        return {
            navList: [],
            title: '',
            date: '',
            fy: '',
            data: []
        };
    },
    created() {
        this.getNavList();
    },
    methods: {
        getNavList() {
            this.navList = this.$route.query.navList;
        }
    }
};
</script>

<style lang="less" scoped>
.fd-news-title {
    padding-top: 35px;
    padding-left: 70px;
    padding-right: 70px;
    text-align: center;
    font-size: 28px;
    color: #000;
    letter-spacing: 1.75px;
    font-weight: 700;
}

.fd-news-message {
    display: flex;
    margin-top: 24px;
    padding-bottom: 6px;
    border-bottom: 1px solid #d7d7d7;
    font-size: 14px;
    color: #40444d;
    justify-content: center;
    letter-spacing: 0.88px;
    text-align: justify;
    line-height: 26px;
    font-weight: 400;

    p:nth-child(1) {
        margin-right: 50px;
    }
}
</style>
